import styled from "styled-components";

/**
 * COOKIE CONSENT BANNER — fixed to the bottom edge so it never pushes content
 * (the layout has hard-sized regions; see the PwaBanner note about in-flow banners).
 */
const Banner = styled.div`
  position: fixed;
  left: var(--space-4);
  right: var(--space-4);
  bottom: var(--space-4);
  z-index: 1000;
  max-width: 720px;
  margin: 0 auto;
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: var(--space-4) var(--space-5);
  display: flex;
  align-items: center;
  gap: var(--space-4);
  text-align: left;

  @media (max-width: 767px) {
    left: var(--space-3);
    right: var(--space-3);
    bottom: var(--space-3);
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-3);
    padding: var(--space-4);
  }
`;

const Text = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-family: var(--font-display);
  font-size: var(--text-base);
  font-weight: var(--weight-semibold);
  color: var(--color-text);
`;

const Description = styled.div`
  margin-top: 2px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  line-height: var(--leading-normal);

  a {
    margin-left: var(--space-1);
    color: var(--color-primary);
    font-weight: var(--weight-semibold);
    white-space: nowrap;
  }

  @media (max-width: 767px) {
    font-size: var(--text-xs);
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;

  @media (max-width: 767px) {
    > button {
      flex: 1;
    }
  }
`;

const AcceptBtn = styled.button`
  height: 36px;
  padding: 0 var(--space-5);
  border-radius: var(--radius-md);
  background: var(--color-gradient);
  color: var(--color-text-on-primary);
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
  border: none;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: var(--shadow-primary);
  transition: var(--transition-all);

  &:hover {
    background: var(--color-gradient-hover);
  }
`;

const DeclineBtn = styled.button`
  height: 36px;
  padding: 0 var(--space-4);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
  border: 1px solid var(--color-border);
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-colors);

  &:hover {
    background: var(--color-bg-muted);
    color: var(--color-text);
  }
`;

export default { Banner, Text, Title, Description, Actions, AcceptBtn, DeclineBtn };
